import { ACTION_CLEAR_PARTNER_EXPORT, ACTION_SET_PARTNER_EXPORT } from '../constants/actions';

export function SetPartnerExport(data = {} as PartnerExportReducer.IState) {
  return {
    payload: { ...data },
    type: ACTION_SET_PARTNER_EXPORT
  };
}

export function ClearPartnerExport() {
  return {
    payload: {},
    type: ACTION_CLEAR_PARTNER_EXPORT
  };
}
